// JsFromRoutes CacheKey 0f9d0ce8e88e372acfffda0b7b4129aa
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/calendar/internal/events/:event_id/test_reminders'),
}
